import { InfoCircleOutlined } from '@ant-design/icons';
import { FC, PropsWithChildren } from 'react';
import { StyledHint } from './HintMessageStyles';

type THintMessageProps = {
  className?: string;
};

const HintMessage: FC<PropsWithChildren<THintMessageProps>> = ({ children, className }) => {
  return (
    <StyledHint className={className}>
      <InfoCircleOutlined />
      <span>{children}</span>
    </StyledHint>
  );
};

export default HintMessage;
